import {isSameDate} from './helper'

export const defaultFiltererServizi = (item, filter) => {
  let checkData = true
  let checkPrezzo = true
  let checkNome = true

  // filter by date
  if (filter.data) {
    checkData = item.dates.some(date => {
      return isSameDate(filter.data, date)
    })
  }

  // filter by price
  if (filter.prezzo) {
    const itemPrice = item.venditaTotaleEuro
    checkPrezzo = itemPrice >= filter.prezzo[0] && itemPrice <= filter.prezzo[1]
  }

  // filter by name
  if (filter.nome) {
    const name = item.detail.name.toLowerCase()
    const filterName = filter.nome.toLowerCase()
    checkNome = name.indexOf(filterName) >= 0
  }
  return checkData && checkPrezzo && checkNome
}

export const defaultSortererServizi = (a, b, order) => {
  const delta = a.venditaTotaleEuro - b.venditaTotaleEuro
  return order.prezzo === 'up' ? delta : -1 * delta
}



// WEBPACK FOOTER //
// ./src/front/utils/serviziUtils.js